export default __webpack_public_path__ + "static/media/shop-rigid.087bf032.svg";